import React from 'react';

export default function PhotoUpload({ onChange }) {
  return (
    <div className="form-group">
      <label htmlFor="tobaccoLicencePhoto">
        Photo Upload of Tobacco Licence <span className="required-asterisk">*</span>
      </label>
      <input
        id="tobaccoLicencePhoto"
        type="file"
        accept="image/*,application/pdf"
        onChange={onChange}
        required
        className="form-input"
      />
      <small className="field-hint">Accepted formats: JPG, PNG, PDF (max 5MB)</small>
    </div>
  );
}
